import { ComponentProps, forwardRef, Children, isValidElement } from 'react'

import { IconProps } from 'components/Icon'
import Loader from 'components/Loader'

import styles from './styles.module.scss'

interface IconButtonProps extends ComponentProps<'button'> {
  isLoading?: boolean
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { className, type = 'button', isLoading, disabled, children, ...props },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        {...props}
        type={type}
        disabled={isLoading || disabled}
        className={[styles.button, className].join(' ')}
      >
        {Children.map(children, (child) => {
          if (isValidElement<IconProps>(child)) {
            const width = child?.props?.width ?? 16
            const height = child?.props?.height ?? width

            return isLoading ? <Loader width={width} height={height} /> : child
          }
        })}
      </button>
    )
  },
)

IconButton.displayName = 'IconButton'
export default IconButton
